import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  app_event: EventEmitter<any> = new EventEmitter();
  constructor() { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // debugger
    // this.app_event.emit({ loading: true, r: Math.random() });
    document.getElementById('loading').style.display = 'flex';
    const token = localStorage.getItem('token');
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'x-api-key': 'hNNwAJWKyH1ABip7HXVsI2cJbCTYs2Pn9s0lJi7s',
        }
      });
    }
    return next.handle(req)
      .pipe(
        finalize(() => {
          document.getElementById('loading').style.display = 'none';
        })
      );
  }
}
